module.exports = __webpack_public_path__ + "img/Group_26993.fa0d352b.svg";